import axios from 'axios'
import { reactive, computed } from 'vue'

export default reactive({
    api: {
    nav: [],
    page: [],
    subnav: [],
    search: {
        active: false,
        query: '',
        results: []
    },
    getData(storeProperty = 'page', apiClass = storeProperty, urlParams = "", apiVersion = "v1") {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*"
            }
        }
        axios.get(`/api/${apiVersion}/${apiClass}${urlParams}`, axiosConfig).then(response => {
            this[storeProperty] = response.data.items
        }).catch(error => console.log(error))
    }
    },
    bodyClass: {},
    messages: {
        list: [],
        setMessage(message, messageClass = "danger") {
            this.list.push({message: message, class: messageClass})
        },
        clearMessage(index) {
            this.list.splice(index)
        },
        clear() {
            this.list = []
        }
    },
    project: {},
    competition: {},
    setMetaTitle(title) {
        document.title = `${title} | Lowell Milken Center`

        // TODO: IF LIVE
        // gtag('config', 'UA-2146008-5', {
        //     'page_path' : router.history.current.path,
        //     'page_title' : title,
        //     'page_location' : window.location.href
        // })
        // window.fbq('track', 'PageView')
    }
})